<template>
  <v-card>
      <v-card-title>
        <!-- <v-flex xs6>
          <cal-picker data-vv-scope="filterForm" :label="filtersLabel.effDate" v-model="filters.effDate"></cal-picker>
        </v-flex> -->
        <v-spacer></v-spacer>
        <v-flex xs6>
          <v-autocomplete :items="constrnClsList" v-model="filters.search" :label="filtersLabel.constrnCls" item-text="label" item-value="value" clearable></v-autocomplete>
        </v-flex>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="filters.search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.constrnCls }}</td>
          <td class="text-xs-left">{{ props.item.constrnClsDesc }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click="doNew">New Construction Class<v-icon>mdi-plus</v-icon></v-btn>
      <v-dialog v-model="constrnClsDialog" max-width="600px" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Permit Construction Class By Product</span>
          </v-card-title>
          <v-card-text>
            <message :messages="messages"></message>
            <v-container grid-list-md>
              <v-layout row wrap>
                <!-- No use Review Method -->
                <!-- <v-flex xs12 v-if="!newConstrnClsProduct">
                  <v-subheader class="queryLabel">{{labels.constrnClsQuery}}</v-subheader>
                  <div class="title">{{constrnClsForm.constrnCls}}</div>
                </v-flex>
                <v-flex xs12 v-else> -->
                <v-flex xs12>
                  <v-autocomplete :label="labels.constrnCls" v-model="constrnClsForm.constrnCls" :items="constrnClsList" item-text="label" item-value="value" :error-messages="errors.collect('constrnCls')" data-vv-name="constrnCls" :data-vv-as="labels.constrnCls" v-validate="'required'" :loading="constrnClsLoading"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
            <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Permitted Product?
        <div class="title">{{deleteProductConstrnCls}}</div>
      </confirm>
    </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import FieldMixin from '@/mixins/field'
export default {
  data() {
    return {
      headers: [
        { text: 'Construction Class', value: 'constrnCls' },
        { text: 'Description', value: 'constrnClsDesc' },
        TableConst.tableActionHeader
      ],
      filtersLabel: {
        constrnCls: 'Construction Class',
        effDate: 'Effective Date'
      },
      filters: {
        effDate: null
      },
      labels: {
        constrnCls: 'Construction Class*',
        constrnClsQuery: 'Construction Class'
      },
      constrnClsForm: {
        constrnCls: null
      },
      pagination: {
        sortBy: 'constrnCls'
      },
      loading: null,
      newProduct: false,
      constrnClsList: [],
      constrnClsDialog: false,
      constrnClsLoading: false,
      newConstrnClsProduct: false,
      deleteProductConstrnCls: '',
      promptRemove: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    productMenu() {
      return this.$store.state.productManagement.product.menu
    }
  },
  methods: {
    async doInit() {
      if (!this.newProduct) {
        // Review
        await this.$store.dispatch('productMenuInit', this.product)
        await this.fetchData(this.product)
      }
    },
    async fetchData(xproduct) {
      const apiURI = this.productMenu.constrnClsProducts
      let expand = {
        product: xproduct
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        if (result.data) {
          this.totalItems = result.data.totalElements
          const { data } = result.data
          if (data) {
            this.items = []
            this.productList = data.productList
            data.map((productConstrnCls) => {
              const convertProductConstrnCls = {
                product: productConstrnCls.product,
                constrnCls: productConstrnCls.constrnCls,
                constrnClsDesc: productConstrnCls.constrnClsDesc
              }
              this.items.push(convertProductConstrnCls)
            })
            this.loading = false
          } else {
            this.items = []
          }
        }
      }
    },
    doClearFilters() {
      this.filters.product = null
      this.filters.constrnCls = null
      this.filters.effDate = null
      this.fetchData(this.product)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(this.product)
        }
      })
    },
    doNew() {
      this.resetMessages()
      this.newConstrnClsProduct = true
      this.constrnClsDialog = true
      this.constrnClsForm.product = this.product
      this.constrnClsForm.constrnCls = null
      this.constrnClsForm.effDate = null
      this.constrnClsForm.endDate = null
    },
    doClose() {
      this.resetMessages()
      this.constrnClsForm.constrnCls = null
      this.constrnClsDialog = false
    },
    // We not use Review to perform in this section
    // async doReview(item) {
    //   const apiURI = this.productMenu.constrnClsProduct
    //   if (apiURI) {
    //     try {
    //       const expand = {
    //         appID: appID.FIRE,
    //         product: item.item.product,
    //         constrnCls: item.item.constrnCls
    //       }
    //       const result = this.$http.get(expandURI(apiURI, expand))
    //       const { data } = result.data
    //       if (data) {
    //         this.busCLsForm.product = data.productConstrnCls.product
    //         this.busCLsForm.constrnCls = data.productConstrnCls.constrnCls
    //         this.constrnClsDialog = true
    //       }
    //     } catch (err) {
    //       const { data } = err.response
    //       if (data) {
    //         this.message(data)
    //         this.fieldMessage(data)
    //       }
    //       this.submitting = false
    //     }
    //   } else {
    //     this.$snotify.error('Invalid API URL - Construction Class Review')
    //   }
    // },
    async constrnClsListInit() {
      const apiURI = this.productMenu.constrnClsList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.constrnClsList = data
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL - Construction List')
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newConstrnClsProduct) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedProductConstrnCls = data
        this.deleteProductConstrnCls = data.constrnCls + ' - ' + data.constrnClsDesc
      }
    },
    async doRemove() {
      const apiURI = this.productMenu.constrnClsProductDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          constrnCls: this.selectedProductConstrnCls.constrnCls,
          product: this.product
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.doInit()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Product Construction Class')
      }
    },
    // We no use update to perform
    // async doUpdate() {
    //   const apiURI = this.menu.constrnClsProductUpdate
    //   if (apiURI) {
    //     this.submitting = true
    //     try {
    //       const result = await this.$http.put(apiURI, this.constrnClsForm)
    //       const { data } = result
    //       if (data) {
    //         // Show message via notify
    //         this.notify(data)
    //         await this.reviewproduct(this.productForm.product)
    //       }
    //       this.submitting = false
    //     } catch (err) {
    //       const { data } = err.response
    //       if (data) {
    //         this.message(data)
    //         this.fieldMessage(data)
    //       }
    //       this.submitting = false
    //     }
    //   } else {
    //     this.$snotify.error('Invalid API URL - Fire Product Construction Class')
    //   }
    // },
    async doCreate() {
      const apiURI = this.productMenu.constrnClsProductCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.constrnClsForm)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)
            this.doClose()
            // Fetch list again
            this.doInit()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Product Construction Class Update')
      }
    }
  },
  mounted() {
    this.constrnClsListInit()
    if (this.product === 'new') {
      this.newProduct = true
    } else {
      this.doInit()
    }
  },
  props: {
    product: {
      type: String,
      default: ''
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
